/**
 * Typed auth-flow errors, kept free of any firebase import so UI components
 * can reference them statically without pulling the Firebase SDK into the
 * main bundle (the SDK loads lazily inside AppContext's dynamic imports).
 * Every code maps 1:1 to an `auth.err.*` message id.
 */

export type AuthFlowErrorCode =
  | "firebase_not_configured"
  | "email_in_use"
  | "bad_email"
  | "weak_password"
  | "bad_credentials"
  | "email_provider_disabled"
  | "google_provider_disabled"
  | "too_many_attempts"
  | "popup_blocked"
  | "popup_closed"
  | "expired_link"
  | "invalid_link"
  | "account_disabled"
  | "unauthorized_domain"
  | "bad_continue_url"
  | "network"
  | "no_firebase_session"
  | "enter_name"
  | "password_mismatch"
  | "unknown";

export class AuthFlowError extends Error {
  constructor(readonly code: AuthFlowErrorCode) {
    super(code);
    this.name = "AuthFlowError";
  }
}
